export default function isInternetExplorer() {
  const userAgent = navigator.userAgent;
  return /MSIE|Trident/.test(userAgent);
}
